import reviewAdminStepPageLoad from "~/store/graphql/queries/reviewAdminStepPageLoad.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminRevisionProcess = async function (
  { commit, dispatch },
  { req, res, params }
) {
  commit("START_LOADING");

  const data = await runGraphQLQuery(
    reviewAdminStepPageLoad,
    params,
    this.$axios,
    req,
    res
  );

  const featureToggles = {
    multipleCategoriesSubmission: this.$unleash.isEnabled(
      "multipleCategoriesSubmission"
    ),
  };

  commit("SET_REVISION_WORKFLOW", { payload: data, featureToggles });
  dispatch("validateSubmission");
  commit("END_LOADING");

  return data;
};

export default loadAdminRevisionProcess;
